import(/* webpackMode: "eager" */ "/app/src/app/(main)/businesses/[handle]/loading.tsx")